export default {
  //loading: 'Chargement…',
  error_bad_request: "Requête invalide.",
  error_not_found: "Élément introuvable.",
  error_fetch: "La requête n’a pas pu aboutir : veuillez vérifier votre connexion ou réessayer plus tard.",
  error_server: "Le serveur a retourné une erreur inattendue. Veuillez réessayer plus tard.",

  // Home
  rafting: "Raft et mini-raft",
  canoraft: "Canoraft",
  hydrospeed: "Hydrospeed",
  pricing: "Tarifs",
  more: "Infos",
  contact: "Contact",
  title: "Rafting à Saint-Lary (65)",
  description:
    "Le rafting est une activité de découverte de l’eau vive et de l’environnement ! Descendez facilement et de manière ludique une portion de rivière qui serait plus difficile à pratiquer en kayak ou canoë traditionnel. C’est une expérience aquatique conviviale en pleine nature !",
  subtitle:
    "Attention ! Si vous réservez vous êtes seuls responsables des effets secondaires qu’une surdose inhabituelle de bonheur pourrait engendrer dans votre vie !",
  cta: "Réserver",
  rafting_description:
    "Venez tester le rafting en vallée d’Aure, une activité de montagne accessible, ludique, aquatique et en pleine nature. 1h30 à 1h45 de navigation et péripéties à bord de ce gros bateau gonflable pour un dépaysement total ! En famille ou entre amis, venez faire un tour de rafting sur l’artère de la vallée, la belle Neste d’Aure.",
  canoraft_description:
    "À deux ou en solo, ces petites embarcations gonflables cousines du raft, aussi appelées airboat ou hot-dog, vous permettront une approche plus autonome et dynamique sur le même parcours, avec une petite surprise à mi-chemin. Déconseillé aux couples fragiles 😜",
  hydrospeed_description:
    "Aussi appelé nage en eau vive, les palmes et cet engin très maniable au début créé pour les secours en eau vive, permettent une approche différente de la rivière. Plus physique que les bateaux gonflables, l’hydrospeed permet d’appréhender et de mieux comprendre les mouvements d’eau et les courants, tout en étant en immersion totale ! Attention, pour apprécier un maximum il est conseillé d’avoir déjà utilisé des palmes, et vous devez avoir 14 ans minimum !",
  duration: "Durée totale : {duration}",
  departures: "RDV à 9h30 ou 14h30",
  price: "Tarif : {price, number, money}",
  what_to_bring: "Matériel à prévoir par vos soins : maillot de bain et chaussures fermées. Tout le reste est fourni !",
  what_to_bring_light: "Matériel à prévoir par vos soins : maillot de bain. Tout le reste est fourni !",
  more_gear:
    "À part les chaussures et le maillot, tout le matériel nécessaire aux activités est inclus ainsi que la navette en minibus pour le retour à la base.",
  more_infos: "Tout le matériel est nettoyé après chaque descente !",
  instructor:
    "Pour lier l’agréable à la sécurité, vos moniteurs : Jean et Charlie, diplômés BPJEPS canoë-kayak et disciplines associées. Ils naviguent depuis plus de 10 ans sur la Neste d’Aure. Ils sont aussi Pisteur-secouristes à la station de ski de Piau-Engaly.",
  legal: "Mentions légales et conditions générales de vente",
  guides: "Jean et Charlie",

  // Calendar
  calendar_title: "Choisissez une date…",
  weekday1: "lundi",
  weekday2: "mardi",
  weekday3: "mercredi",
  weekday4: "jeudi",
  weekday5: "vendredi",
  weekday6: "samedi",
  weekday7: "dimanche",
  morning: "Matin",
  afternoon: "Après-midi",
  spots: "{num, plural, one {Une place} other {# places}}",
  full: "complet",
  closed: "fermé",
  after_season: "Désolé, la saison est terminée. À l’année prochaine !",

  // Book
  book_title: "Confirmez votre réservation…",
  tomorrow_alert: "Réservez avant 21h pour pouvoir naviguer demain !",
  total: "Total : {amount, number, money}",
  deposit: "À payer : {percent}% d’accompte soit {amount, number, money}",
  remaining: "Reste à payer sur place : {amount, number, money}",
  discount: "Cliquez ici si vous avez un code promo",
  discount_placeholder: "Code promo…",
  discount_checking: "Vérification…",
  discount_percent: "Dont vos {discount}% de réduction !",
  checkout_title: "Réserver pour {people, plural, one {une personne} other {# personnes}}",
  checkout_description: "Le {date, date, event} pour {type, select, morning {le matin} afternoon {l’après-midi}}",
  checkout_label: "Payer",
  checkout_button: "Payer",
  paying: "Réservation…",
  error_too_late: "Désolé, il est trop tard pour réserver pour cette journée.",
  error_missing_spots: "Désolé, il n’y a plus assez de place.",
  error_full: "Désolé, cette journée est complète.",
  error_closed: "Désolé, nous sommes fermés ce jour là.",
  error_code_not_found: "Ce code n’existe pas ou n’est plus valide.",
  unavailable_combination:
    "Désolé, cette combinaison n’est pas disponible. Essayez de changer de créneau ou d’activité.",

  // Thanks
  thanks_title: "Voilà !",
  thanks:
    "Merci pour votre réservation. Si votre paiement est validé, vous allez recevoir une confirmation par e-mail avec toutes les informations.",

  // Forms
  form_name: "Prénom + Nom",
  form_email: "Adresse e-mail",
  form_message: "Votre message",
  form_phone: "Téléphone",
  form_people: "Personnes",
  option_type: "{type, select, morning {Le matin} afternoon {L’après-midi}}",
  activities: "Activité :",
  option_activity:
    "{activity, select, rafting {Raft / mini-raft} canoraft {Canoraft (air boat / hot-dog)} hydrospeed {Hydrospeed (nage en eau vive)}}",
  option_activity_max: "{max, plural, one {1 place} other {# places}}",
  form_confirm: "Je certifie que tout le monde sait nager",
  form_referral: "Comment nous avez-vous connu ?",
  incomplete_form: "Veuillez compléter le formulaire pour accéder au paiement.",
  send: "Envoyer",
  sent: "Votre message a été envoyé. Une réponse vous sera faite dans les plus brefs délais.",
  unavailable: "Indisponible",
}
